import { dummySelectWrapper, lookupNestedProp, setNestedProp } from "./Table";
import { getEditable, getEditKey } from "./TableEditCell";
import { Calculator } from "./Calculator";
import { autoFormat } from "../../pages/project/manage/summary/AutoFormat";
export class PasteError extends Error {
    constructor(rowLabel, column, message) { super(`${rowLabel}, ${column}: ${message}`); this.rowLabel = void 0; this.column = void 0; this.rowLabel = rowLabel; this.column = column; }
}
export function pasteRowLabel(row, index) { if (typeof (row === null || row === void 0 ? void 0 : row.name) === "string" && row.name.trim() !== "")
    return row.name; return `row ${index + 1}`; } // applyPastedRow builds the updated row for a paste (or a range delete) and runs the same
// per-cell hooks a single-cell edit runs, so a paste can't store a value an edit would reject.
// cells[i] is the clipboard text for columns[i]. Cells are applied left to right, and then
// every pasted select column is checked against its options using the finished row, because
// the options can depend on other cells in the same row (e.g. handing depends on opening type).
export function applyPastedRow(columns, src, cells, rowLabel) {
    const obj = Object.assign({}, src);
    const pasted = [];
    cells.forEach((strValue, index) => {
        if (index >= columns.length)
            return;
        const column = columns[index]; // a disabled cell can't be edited, so a paste into it is ignored
        if (column.disabled && column.disabled(obj))
            return;
        try {
            applyPastedCell(column, obj, src, strValue);
        }
        catch (e) {
            if (e instanceof PasteError)
                throw e;
            throw new PasteError(rowLabel, column.name, (e === null || e === void 0 ? void 0 : e.message) || (e === null || e === void 0 ? void 0 : e.toString()) || "invalid value");
        }
        pasted.push(column);
    });
    for (const column of pasted) {
        checkSelectOption(column, obj, rowLabel);
    }
    return obj;
}
function applyPastedCell(column, obj, src, strValue) {
    const editKey = getEditKey(column, obj);
    const editable = getEditable(column, obj);
    if (editable !== null && editable !== void 0 && editable.paste) {
        editable.paste(obj, strValue);
        return;
    }
    if (!editKey) {
        if ((editable === null || editable === void 0 ? void 0 : editable.type) === "button")
            return;
        if (column.editObj)
            column.editObj(obj, src, strValue);
        return;
    } // @ts-ignore
    const current = lookupNestedProp(obj, editKey);
    let value = strValue;
    if (editable !== null && editable !== void 0 && editable.parseValue) {
        value = editable.parseValue(current, strValue);
    }
    else if ((editable === null || editable === void 0 ? void 0 : editable.type) === "number" || typeof current === "number") {
        value = strValue.trim() === "" ? null : Calculator.eval(strValue);
    }
    else if ((editable === null || editable === void 0 ? void 0 : editable.type) === "checkbox" || typeof current === "boolean") {
        value = strValue.toLowerCase() === "true";
    }
    if (editable !== null && editable !== void 0 && editable.validate) {
        editable.validate(value);
    }
    if ((editable === null || editable === void 0 ? void 0 : editable.type) === "string" && editable.autoFormat) {
        value = autoFormat(value, editable.autoFormat);
    }
    if (editable !== null && editable !== void 0 && editable.onChangeBeforeSave) {
        editable.onChangeBeforeSave(obj, strValue);
    }
    if (column.editObj) {
        column.editObj(obj, src, value);
        return;
    } // @ts-ignore
    setNestedProp(obj, editKey, value);
} // checkSelectOption rejects a pasted select value that isn't in the column's options for the
// finished row, and normalizes a value that matches an option's value or display text
// (case-insensitive) to the option's value.
function checkSelectOption(column, obj, rowLabel) {
    const editable = getEditable(column, obj);
    if (!editable || editable.type !== "select" || editable.freeSolo)
        return;
    const editKey = getEditKey(column, obj);
    if (!editKey)
        return; // @ts-ignore
    const value = lookupNestedProp(obj, editKey);
    if (value === null || value === undefined || value === "")
        return;
    const options = editable.options(dummySelectWrapper(obj)).filter(o => !o.subHeading && !o.disabled);
    if (options.some(o => o.value === value))
        return;
    const str = String(value).trim().toLowerCase();
    const match = options.find(o => String(o.value).toLowerCase() === str || o.display.toLowerCase() === str);
    if (match) { // @ts-ignore
        setNestedProp(obj, editKey, match.value);
        return;
    }
    throw new PasteError(rowLabel, column.name, `"${value}" is not a valid option`);
} // pasteErrorSummary joins a list of paste errors into one message, limited to the first few.
export function pasteErrorSummary(errors) { let limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5; const shown = errors.slice(0, limit).map(e => e.message); if (errors.length > limit) {
    shown.push(`and ${errors.length - limit} more`);
} return "Paste cancelled. " + shown.join("; "); }
